import {
    fillGetParamsFromStorage,
    getOffset,
    isLoading, parseGetParams,
    reachedEnd,
    resetFilter,
    setLoading,
    setOffset,
    setReachedEnd
} from "./utils/requestUtils";
import {addParamToUrl, removeParamFromUrl, sanitizeFilterInputName} from "./utils/urlUtils";
import {getScrollPercent} from "./utils/screenUtils";

const itemsPerPage = parseInt(document.getElementById("items-per-page").dataset.value);

//City select cache
const originalFilterCity = $("#filter_city").html();

parseGetParams();
fillGetParamsFromStorage();
fixColorsLayout();

$(function () {
    //filterProducts(false);
    filterProducts();

    function addInputToUrl(inputObject) {
        let name = sanitizeFilterInputName(inputObject.attr("id"));
        let value = inputObject.val();
        addParamToUrl(name, value);
    }

    $("#filter_country").change(handleCountryChange);
    handleCountryChange();

    function handleCountryChange() {
        let value = $("#filter_country").val();
        localStorage.setItem("filterCountry", value);
        localStorage.setItem("filterCountryName", $("#filter_country").find("option:selected").text());
        addInputToUrl($("#filter_country"));

        //city select
        $("#filter_city").val("");
        localStorage.removeItem("filterCity");
        removeParamFromUrl("city");

        if(value) {
            $(".filter_city-group").show();
            $("#filter_city").html(originalFilterCity);

            $("#filter_city option[data-country!='" + value + "']").remove();
            $("#filter_city").prepend($('<option>', {
                value: '',
                text: ''
            }));
        } else {
            $(".filter_city-group").hide();
        }

        filterProducts();
    }

    $("#filter_city").change(function() {
        console.log($(this).val());
        localStorage.setItem("filterCity", $(this).val());
        addInputToUrl($(this));
        filterProducts();
    });

    $("#filter_price_price_min").on("keyup", function() {
        localStorage.setItem("filterPriceMin", $(this).val());
        addInputToUrl($(this));
        filterProducts();
    });

    $("#filter_price_price_max").on("keyup", function() {
        localStorage.setItem("filterPriceMax", $(this).val());
        addInputToUrl($(this));
        filterProducts();
    });

    $("[id^=filter_size_]").change(function() {
        //let input = $(this);
        //let value = input.val();

        let values = $("[id^=filter_size_]:checked");
        let ids = [];
        let sizeNames = [];

        values.each(function () {
            ids.push($(this).val());
            sizeNames.push($(this).next().find(".text-body").text())
        });

        localStorage.setItem("filterSizes", ids);
        localStorage.setItem("filterSizeNames", sizeNames);

        /*
        let sizesString = localStorage.getItem("filterSizes");
        let sizesArray = sizesString.split(",");

        if(input.is(":checked")) {
            if (sizesArray.indexOf(value)===-1) {
                sizesArray.push(value);
            }
        } else {
            let index = sizesArray.indexOf(value)
            if(index > -1){
                sizesArray.splice(index, 1);
            }
        }

        let sizesStringModified = sizesArray.join();

        localStorage.setItem("filterSizes", sizesStringModified);*/
        addParamToUrl("sizes", ids.join(','))

        filterProducts();
    });

    $("[id^=filter_quality_]").change(function() {
        //let input = $(this);
        //let value = input.val();

        let values = $("[id^=filter_quality_]:checked");
        let ids = [];
        let names = [];

        values.each(function () {
            ids.push($(this).val());
            names.push($(this).next().text())
            console.log(names);
        });

        localStorage.setItem("filterQualities", ids);
        localStorage.setItem("filterQualityNames", names);

        /*
        let qualitiesString = localStorage.getItem("filterQualities");
        let qualitiesArray = qualitiesString.split(",");

        if(input.is(":checked")) {
            if (qualitiesArray.indexOf(value)===-1) {
                qualitiesArray.push(value);
            }
        } else {
            let index = qualitiesArray.indexOf(value)
            if(index > -1){
                qualitiesArray.splice(index, 1);
            }
        }

        let qualitiesStringModified = qualitiesArray.join();

        localStorage.setItem("filterQualities", qualitiesStringModified);*/

        addParamToUrl("qualities", ids.join(','))

        filterProducts();
    });

    $("[id^=filter_color_]").change(function() {
        let input = $(this);
        let value = input.val();

        let values = $("[id^=filter_color_]:checked");
        let ids = [];
        let names = [];

        values.each(function () {
            ids.push($(this).val());
            names.push($(this).next().text())
            console.log(names);
        });

        localStorage.setItem("filterColors", ids);
        localStorage.setItem("filterColorNames", names);

        /*
        let colorsString = localStorage.getItem("filterColors");
        let colorsArray = colorsString.split(",");

        if(input.is(":checked")) {
            if (colorsArray.indexOf(value)===-1) {
                colorsArray.push(value);
            }
        } else {
            let index = colorsArray.indexOf(value)
            if(index > -1){
                colorsArray.splice(index, 1);
            }
        }

        let colorsStringModified = colorsArray.join();

        localStorage.setItem("filterColors", colorsStringModified);*/
        addParamToUrl("colors", ids.join(','))

        filterProducts();
    });

    $("#top-bar input, #top-bar select").change(function () {
        setOffset(0);
        setReachedEnd(false);
        filterProducts();
    });

    window.onscroll = function (ev) {
        if (isLoading() || reachedEnd()) {
            return;
        }

        if (getScrollPercent() > 30) {
            let offset = getOffset() + itemsPerPage;
            setOffset(offset)

            filterProducts(false);
        }
    };

    $(document).on("click", ".reset-filter-button", function() {
        resetFilter();
    })

    $(document).on("click", ".change-currency-dropdown a", function() {
        removeParamFromUrl("price_min");
        removeParamFromUrl("price_max");
        localStorage.removeItem("filterPriceMin");
        localStorage.removeItem("filterPriceMax");
    })

    $("#add-saved-search-button").click(function(e) {
        e.preventDefault();
        $("#add-saved-search-button").css("pointer-events", "none");
        addSavedSearch();
    });
});


function filterParams() {
    return {
        country: localStorage.getItem("filterCountry"),
        city: localStorage.getItem("filterCity"),
        sizes: localStorage.getItem("filterSizes"),
        qualities: localStorage.getItem("filterQualities"),
        colors: localStorage.getItem("filterColors"),
        priceMin: localStorage.getItem("filterPriceMin"),
        priceMax: localStorage.getItem("filterPriceMax"),
        offset: localStorage.getItem("filterOffset")
    }
}

function columnsEqualHeight() {
    let items = document.querySelectorAll(".product-item");
    let maximum = 0;

    for(let i = 0; i < items.length; i++) {
        let item = items[i];
        let height = item.offsetHeight;

        if(height > maximum) {
            maximum = height;
        }
    }

    if(maximum > 0) {
        for(let i = 0; i < items.length; i++) {
            let item = items[i];
            item.style.height=maximum + "px";
        }
    }
}

function filterProducts(resetOffset = true){
    setLoading(true);

    if(resetOffset) {
        setReachedEnd(false);
        setOffset(0);
    }

    const searchResult = $("#search-result");

    let params = filterParams();

    console.log(params);

    $.ajax({
        method: "GET",
        url: "/parts/filtered-products",
        data: params,
        success: function (result) {
            setLoading(false);
            if(result === "") {
                console.log("reached end");
                setReachedEnd(true);
            } else {
                if(resetOffset) {
                    //if scroll position is not at the top
                    if($(window).scrollTop() > 50) {
                        document.getElementById("search-result").scrollIntoView();
                        window.scrollBy(0, -100);
                    }

                    searchResult.html(result);
                } else {
                    searchResult.append(result);
                }

                searchResult.waitForImages(function() {
                    columnsEqualHeight();
                });
            }

            $("#added-saved-search").removeClass("d-inline-block").addClass("d-none");
            $("#add-saved-search-button").removeClass("d-none").addClass("d-inline-block");
        }
    })
}

function addSavedSearch() {
    let params = filterParams();

    console.log(params);

    $.ajax({
        method: "POST",
        url: "/api/saved-search/add",
        data: params,
        success: function (result) {
            $("body").append(result.html);

            $("#add-saved-search-button").removeClass("d-inline-block").addClass("d-none");
            $("#add-saved-search-button").css("pointer-events", "auto");
            $("#added-saved-search").removeClass("d-none").addClass("d-inline-block");
        }
    })
}

const url = location.href;
console.log(url);
if(url.indexOf('?')!==-1)
{
    const ary = url.split('?')[1].split('&');

    for(let i=0;i<=ary.length-1;i++)
    {
        let name = ary[i].split('=')[0];
        var val = ary[i].split('=')[1];
        console.log("got " + name + " " + val);

        if (!val) {
            continue;
        }

        let target = document.getElementById("product_" + name);
        if(!target) {
            target = document.getElementById(name);
        }

        if(target) {
            console.log("set value of " + target.id);

            if(target.type && target.type === "checkbox") {
                target.checked = true;
            } else {
                target.value = val;
            }
        } else {
            console.log("not found input for url parameter " + name);
        }
    }
}

function fixColorsLayout() {
    let colors = document.querySelectorAll(".product-color");

    for(let i = 0; i < colors.length; i++) {
        let colorItem = colors[i];
        let label = colorItem.nextElementSibling;
        let backgroundColor = colorItem.dataset.backgroundColor;
        let color = colorItem.dataset.color;

        colorItem.classList.remove('product-color');
        label.classList.add('product-color');
        label.style.backgroundColor = backgroundColor;
        label.style.color = color;
    }
}

window.addEventListener('resize', function(event) {
    let items = document.querySelectorAll(".product-item");
    for(let i = 0; i < items.length; i++) {
        let item = items[i];

        item.style.removeProperty("height");
    }

    columnsEqualHeight();
}, true);